import { Dialog as BaseDialog } from "@base-ui/react/dialog";
import { X } from "lucide-react";
import type { ComponentProps, ReactNode } from "react";
import { cn } from "../utils";

export const Dialog = BaseDialog.Root;
export const DialogTrigger = BaseDialog.Trigger;
export const DialogClose = BaseDialog.Close;

export function DialogContent({
  className,
  children,
  title,
  description,
  ...props
}: ComponentProps<typeof BaseDialog.Popup> & {
  title: ReactNode;
  description?: ReactNode;
}) {
  return (
    <BaseDialog.Portal>
      <BaseDialog.Backdrop
        className={cn(
          "fixed inset-0 z-50 bg-ink/40 backdrop-blur-[2px]",
          "transition-opacity duration-200 ease-swift",
          "data-[starting-style]:opacity-0 data-[ending-style]:opacity-0",
        )}
      />
      <BaseDialog.Popup
        className={cn(
          "fixed left-1/2 top-1/2 z-50 w-full max-w-md -translate-x-1/2 -translate-y-1/2",
          "rounded-surface border border-line bg-surface-overlay shadow-overlay",
          "transition-[transform,opacity] duration-200 ease-swift",
          "data-[starting-style]:-translate-y-[calc(50%+0.5rem)] data-[starting-style]:opacity-0",
          "data-[ending-style]:opacity-0",
          className,
        )}
        {...props}
      >
        <div className="flex items-start justify-between gap-4 border-b border-line px-4 py-3">
          <div className="flex flex-col gap-0.5">
            <BaseDialog.Title className="text-sm font-semibold text-ink">
              {title}
            </BaseDialog.Title>
            {description && (
              <BaseDialog.Description className="text-2xs text-ink-muted">
                {description}
              </BaseDialog.Description>
            )}
          </div>
          <BaseDialog.Close
            className="rounded-control p-1 text-ink-muted transition-colors hover:bg-surface-sunken hover:text-ink"
            aria-label="Fechar"
          >
            <X className="size-4" />
          </BaseDialog.Close>
        </div>
        <div className="p-4">{children}</div>
      </BaseDialog.Popup>
    </BaseDialog.Portal>
  );
}
